module.exports = __webpack_public_path__ + "site/img/footerf.6484a83f.png";